import { getLogger } from '@ravago/shared/logging/client';
import { TypeSalesTermsAndConditions, TypeSalesTermsAndConditionsFields } from '@ravago/shared/page-data/models/contentful-generated';
import { NormalizedCollection, NormalizedSalesTermCondition } from '@ravago/shared/page-data/models/contentful-mapped';
import { ContentfulUtils } from '@ravago/shared/page-data/utils/contentful';
import { DataMapperUtils } from '@ravago/shared/page-data/utils/data-mapper';
import { LogMessageUtils } from '@ravago/shared/page-data/utils/logging';
import { validateAndFilterSalesTermsAndConditionsEntries, validateSalesTermsAndConditionsEntry } from '@ravago/shared/page-data/validators';

import { ContentfulClientApi } from 'contentful';

export class LegalEntitiesUtils {
  static async getLegalEntities(contentfulClientApi: ContentfulClientApi, locale: string): Promise<NormalizedCollection<NormalizedSalesTermCondition>> {
    try {
      const entries = await contentfulClientApi.getEntries<TypeSalesTermsAndConditionsFields>({ content_type: 'salesTermsAndConditions', locale, limit: 1000, include: 2 });

      if (!entries.total) return ContentfulUtils.getDefaultCollection();

      const validEntries = validateAndFilterSalesTermsAndConditionsEntries(entries.items);

      entries.items = validEntries;

      return DataMapperUtils.normalizeContentfulCollection<NormalizedCollection<NormalizedSalesTermCondition>>(entries, DataMapperUtils.normalizeContentfulSalesTermCondition);
    } catch (error) {
      getLogger().error(error instanceof Error ? error.message : 'Unknown error occurred.');

      return ContentfulUtils.getDefaultCollection();
    }
  }

  static async getLegalEntityByOleId(contentfulClientApi: ContentfulClientApi, locale: string, oleId: string): Promise<NormalizedSalesTermCondition | null> {
    try {
      const entries = await contentfulClientApi.getEntries<TypeSalesTermsAndConditionsFields>({ content_type: 'salesTermsAndConditions', locale, limit: 1, include: 2, 'fields.ole.sys.contentType.sys.id': 'footerCountryInfo', 'fields.ole.fields.oleId': oleId });

      if (!entries.total) return null;

      const validationResult = validateSalesTermsAndConditionsEntry(entries.items?.[0]);

      if (!validationResult.success) {
        console.error(LogMessageUtils.validationFailed('SALES_TERMS_AND_CONDITION'), validationResult.error.message);

        return null;
      }

      return DataMapperUtils.normalizeContentfulSalesTermCondition(validationResult.data as unknown as TypeSalesTermsAndConditions);
    } catch (error) {
      getLogger().error(error instanceof Error ? error.message : 'Unknown error occurred.');

      return null;
    }
  }
}
